<style scoped>

</style>
<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
    @input="changeShow"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="display"
        :label="label"
        :placeholder="placeholder"
        :required="required"
        :rules="rules"
        :disabled="disabled"
        :prepend-icon="prependIcon"
        readonly
        :clearable="clearable"
        v-bind="$attrs"
        @click:clear="clear"
        v-on="on"
      >
        <template v-slot:label> 
          <span class="label"><span
            v-show="required"
            style="color:red"
          >*</span>{{ label }}</span>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      range
      :type="type"
      :locale="locale"
      :allowed-dates="allowedDates"
      scrollable
      @input="changeDate"
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="close"
      >
        关闭
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
  import { throttle } from '@/libs/functions_utils'
  export default {
    props: {
      value: {
        type: Object
      },
      label: {
        type: String,
        default: '选择日期'
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
      locale: {
        type: String,
        default: 'zh'
      },
      required: {
        type: Boolean,
      },
      rules: {
        type: Array,
      },
      allowedDates: {
        type: Function,
        default: () => true
      },
      type: {
        type: String,
        default: () => undefined
      },
      start_key: {
        type: String,
      },
      end_key: {
        type: String,
      },
      prependIcon: {
        type: String,
        default: () => 'mdi-calendar'
      },
      popChange: {
        type: Function,
      },
      disabled: {
        type: Boolean,
      },
      clearable: {
        type: Boolean,
      }
    },
    data() {
      return {
        menu: false,
        date: []
      }
    },
    computed: {
      display() {
        const start = this.value[this.start_key]
        const end = this.value[this.end_key]
        const arr = [start, end].filter(item => !!item)
        return arr.length ? arr : ''
      }
    },
    mounted() {
      if (this.display) {
        this.date = this.display
      }
    },
    created() {
      this.__changeShow = throttle.call(this, this._changeShow, 100)
    },
    methods: {
      clear() {
        this.date = []
        this.value[this.start_key] = null
        this.value[this.end_key] = null
        this.$emit('click:clear', null)
      },
      _changeShow(val) {
        if (this.popChange) {
          this.popChange(val, this.date)
        }
      },
      changeShow(val) {
        if (this.__changeShow) {
          this.__changeShow(val)
        }
      },
      close() {
        this.$refs.menu.save()
      },
      changeDate(date_arr) {
        date_arr = [...date_arr].filter(item => !!item)
        date_arr.sort()
        this.$nextTick(() => {
          this.date = date_arr
        })
        this.$emit('input', date_arr);
      },
    }
  }
</script>
